import React, { useCallback, useEffect, useState } from "react";

import { getNotificationList } from "services";

import { useCancelAsyncOnUnmount, useTranslation, useUserContext } from "utils";

import { Col, MainPage, NotificationCard, Row, Typography } from "components";

export const Notifications = ({ handleNotificationClickCallback }) => {
  const { t } = useTranslation(["notifications", "meta"]);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const { reloadUserData } = useUserContext();

  const loadNotificationList = useCallback(() => {
    setLoading(true);

    getNotificationList({
      signal,
    })
      .then((res) => {
        setNotifications(res.notifications);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
        /* need this because all the notifications will be set to 'read' in the BE after we fetch the notification once
         and the user keeps track of unread notifications which we need in the Header to display the notification count */
        reloadUserData();
      });
  }, [signal]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    loadNotificationList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"notifications"}>
      <section className="container tiny">
        <Row>
          <Col>
            <Typography variant="h1">{t("titles.title")}</Typography>
          </Col>
        </Row>
        {notifications.length > 0 ? (
          <Row>
            {/* prelint-ignore-col */}
            {notifications.map((notification, i) => (
              <Col key={i}>
                <NotificationCard notification={notification} handleNotificationClickCallback={handleNotificationClickCallback} />
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            <Col>
              <Typography variant="paragraph-m">{t("noUnread")}</Typography>
            </Col>
          </Row>
        )}
      </section>
    </MainPage>
  );
};
